module.exports = __webpack_public_path__ + "assets/fs-yuangongrenzheng.fa388171.svg";